import React from "react";

const ProfilePhotoModal = ({imgPath}) => {
    return (
        <img className="photo-modal" src={imgPath}></img>
    )
}

export default ProfilePhotoModal;